import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { FACILITY_ACTIVE_TYPE } from '@constants/facilityTypes';

import { calcLink } from '@helpers/calcLink';

import { useFacilitiesListQuery } from '@services/useFacilitiesListQuery';

import { useMapActions } from '../store/useMapStore';

export const useMapData = (filterIds) => {
  const { pathname } = useLocation();
  const { customerId } = useParams();

  const { setMapData } = useMapActions();
  const { data: facilityListData } = useFacilitiesListQuery();

  useEffect(() => {
    if (!facilityListData) return;

    let allowedAreas = {};
    let continents = {};
    let tabs = {};
    let tabsSortedArr = [];
    let legend = {};
    let facility = [];

    let facilityList = Object.values(facilityListData || {});

    if (filterIds?.length) {
      const filterIdsObject = filterIds.reduce((obj, item) => {
        obj[item] = true;
        return obj;
      }, {});

      facilityList = facilityList.filter((facility) => filterIdsObject[facility.location_id]);
    }

    facilityList.forEach((facilityItem) => {
      const { location_id, lat, lng, name, facility_id, status_type, country, mapMarker, currency } =
        facilityItem;

      if (country && +status_type === FACILITY_ACTIVE_TYPE) {
        const marker = {
          lat,
          lng,
          name,
          facility_id,
          mapMarker,
          url: calcLink(pathname, customerId, location_id),
          continent: country.continent?.name,
          country: country.name,
          region: country.state?.long_name,
          facility_info: {
            facility_id: facility_id,
            facility: name || '',
            id: location_id,
            name: name,
            level_name: 'facility',
            currency,
          },
        };

        allowedAreas[country.continent?.name] = true;
        allowedAreas[country.name] = true;
        allowedAreas[country.state?.long_name] = true;

        continents[country.continent?.name] = true;

        tabs[country.name] ? tabs[country.name].push(marker) : (tabs[country.name] = [marker]);

        if (mapMarker && !legend[mapMarker.name]) {
          legend[mapMarker.name] = mapMarker;
        }

        facility.push(marker);
      }
    });

    tabsSortedArr = Object.entries(tabs)
      .sort((a, b) => b[1].length - a[1].length)
      .map(([key, value]) => [key, value.sort((a, b) => a.name.localeCompare(b.name))]);

    setMapData({ allowedAreas, continents, tabsSortedArr, legend, facility });
  }, [facilityListData, filterIds]);
};
